/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Case manager details for find-or-create (use case_manager_id instead when selecting existing)
 * @export
 * @interface UpdatePalReauthSubmissionRequestCaseManager
 */
export interface UpdatePalReauthSubmissionRequestCaseManager {
    /**
     * 
     */
    name?: string | null;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    fax?: string | null;
    /**
     * 
     */
    email?: string | null;
}

/**
 * Check if a given object implements the UpdatePalReauthSubmissionRequestCaseManager interface.
 */
export function instanceOfUpdatePalReauthSubmissionRequestCaseManager(value: object): value is UpdatePalReauthSubmissionRequestCaseManager {
    return true;
}

export function UpdatePalReauthSubmissionRequestCaseManagerFromJSON(json: any): UpdatePalReauthSubmissionRequestCaseManager {
    return UpdatePalReauthSubmissionRequestCaseManagerFromJSONTyped(json, false);
}

export function UpdatePalReauthSubmissionRequestCaseManagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthSubmissionRequestCaseManager {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'fax': json['fax'] === undefined ? undefined : json['fax'] === null ? null : json['fax'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
    };
}

export function UpdatePalReauthSubmissionRequestCaseManagerToJSON(json: any): UpdatePalReauthSubmissionRequestCaseManager {
    return UpdatePalReauthSubmissionRequestCaseManagerToJSONTyped(json, false);
}

export function UpdatePalReauthSubmissionRequestCaseManagerToJSONTyped(value?: UpdatePalReauthSubmissionRequestCaseManager | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'phone': value['phone'],
        'fax': value['fax'],
        'email': value['email'],
    };
}

